import styled from "styled-components";

export const ObsButton = styled.div`
  border-radius: 50%;
  min-width: 34px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #222;
  flex-shrink: 0;
  padding: 0;
  cursor: pointer;
`;